// for doing something different from centene, without breaking centene
// or having some crazy long standing branch.
export default {
  // raggedLayout: true,
  // smallTiles: false
  layout: "expanded"
}
